import { render, staticRenderFns } from "./GameGenreDetail.vue?vue&type=template&id=0acb62e6"
import script from "./GameGenreDetail.vue?vue&type=script&lang=js"
export * from "./GameGenreDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports